import Http from "@api/http";

export async function getSumajobStaffDetail() {
  try {
    const result = await Http.get("/sumajob-staff");
    return result;
  } catch ({ response }) {
    return response;
  }
}

// /**
//  * Confirm Movie Check
//  *
//  * @param  any params [description]
//  *
//  * @return any
//  */
export async function confirmMovieCheck() {
  try {
    const result = await Http.post("/sumajob-staff/confirm-movie");
    return result;
  } catch (err) {
    return err;
  }
}

/**
 * Change password
 *
 * @param  any params [description]
 *
 * @return any
 */
export async function changePassword(params) {
  try {
    const rs = await Http.post("/sumajob-staff/change-pass", params);
    return rs;
  } catch (err) {
    return err;
  }
}
export async function checkStaff(params) {
  try {
    const rs = await Http.get("/sumajob-staff/check-staff", params);
    return rs;
  } catch (err) {
    return err;
  }
}

export async function sendMailStaffForeigner(params) {
  try {
    const result = await Http.post("/sumajob-staff/send-mail", params);
    return result;
  } catch (err) {
    return err.response.data;
  }
}

export async function updateStaffShowNotification() {
  try {
    const rs = await Http.post("sumajob-staff/update-staff-show-notification");
    return rs;
  } catch (error) {
    return error;
  }
}
